// src/lib/Toast.ts

type ToastOptions = {
  durationMs?: number;
  position?: "bottom-right" | "top-center";
};

export const showToast = (
  message: string,
  type: "success" | "error" | "warning" = "success",
  options: ToastOptions = {}
) => {
  // Remove existing toast to prevent stacking
  const existingToast = document.querySelector(".custom-toast-container");
  if (existingToast) existingToast.remove();

  const toast = document.createElement("div");
  toast.className = "custom-toast-container";
  const { durationMs = 10000, position = "bottom-right" } = options;

  // Accent colors
  const accentColor = type === "success" ? "#07625C" : type === "warning" ? "#d97706" : "#dc2626";
  const iconBackgroundColor =
    type === "success" ? "#ecfdf5" : type === "warning" ? "#fffbeb" : "#fef2f2";
  const icon = type === "success" ? "✅" : type === "warning" ? "!" : "❌";
  const title = type === "success" ? "Success" : type === "warning" ? "Warning" : "Notification";

  const positionStyles =
    position === "top-center"
      ? {
          top: "24px",
          left: "50%",
          transform: "translateX(-50%)",
        }
      : {
          bottom: "40px",
          right: "40px",
        };

  // Apply "Beautiful White Card" styles
  Object.assign(toast.style, {
    position: "fixed",
    backgroundColor: "#ffffff",
    color: "#1f2937", // Dark grey text
    padding: "12px 20px",
    borderRadius: "12px",
    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    zIndex: "99999",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minWidth: "350px",
    borderLeft: `6px solid ${accentColor}`, // The beautiful accent line
    transition: "all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
    fontFamily: "'Inter', sans-serif",
    border: "1px solid #f3f4f6", // Very light border
    ...positionStyles,
  });

  toast.innerHTML = `
    <div style="display: flex; align-items: center; gap: 15px;">
      <div style="
        background-color: ${iconBackgroundColor};
        padding: 8px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      ">
        <span style="font-size: 18px;">${icon}</span>
      </div>
      <div style="display: flex; flex-direction: column;">
        <span style="font-size: 14px; font-weight: 600; color: #111827;">
          ${title}
        </span>
        <span style="font-size: 13px; color: #6b7280; margin-top: 2px;">${message}</span>
      </div>
    </div>
    <button id="close-toast-btn" style="
      background: none;
      border: none;
      color: #9ca3af;
      cursor: pointer;
      font-size: 18px;
      width: 32px;
      height: 32px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s;
    ">✕</button>
  `;

  document.body.appendChild(toast);

  const removeToast = () => {
    toast.style.opacity = "0";
    toast.style.transform =
      position === "top-center" ? "translate(-50%, -12px)" : "translateX(50px)";
    setTimeout(() => toast.remove(), 500);
  };

  // Close Button Logic
  const btn = toast.querySelector("#close-toast-btn") as HTMLElement;
  if (btn) {
    btn.onclick = (e) => {
      e.stopPropagation();
      removeToast();
    };
    btn.onmouseenter = () => {
      btn.style.backgroundColor = "#f3f4f6";
      btn.style.color = "#111827";
    };
    btn.onmouseleave = () => {
      btn.style.backgroundColor = "background-color";
      btn.style.color = "#9ca3af";
    };
  }

  // Auto-remove after 10 seconds
  setTimeout(() => {
    if (document.body.contains(toast)) removeToast();
  }, durationMs);
};
